import { getAxiosInstance } from "./axiosInstance";

/**
 * Get latest OBD data
 *
 * Supported:
 *   ?imei=866192070567134
 *   ?reg_no=AS01AA0005
 *   ?imei=866192070567134&datetime=2026-09-10T10:00:00Z
 */
const getLatestOBDData = (params) => {
  const http = getAxiosInstance();

  return http.get("/api/public/obd/latest/", {
    params,
  });
};

/**
 * Get historical OBD data
 *
 * Supported:
 *   ?imei=866192070567134
 *   ?reg_no=AS01AA0005
 *
 * With date range:
 *   ?imei=866192070567134
 *   &start_datetime=2026-09-10T00:00:00Z
 *   &end_datetime=2026-09-10T12:00:00Z
 */
const getHistoricalOBDData = (params) => {
  const http = getAxiosInstance();

  return http.get("/api/public/obd/history/", {
    params,
  });
};

const OBDDataService = {
  getLatestOBDData,
  getHistoricalOBDData,
};

export default OBDDataService;